import React from "react";

const LazyAvalibility = React.lazy(() => import("./avalibility"));

const Avalibility = (props: Record<string, any>) => (
  <React.Suspense fallback={<div className='transition-loader'><img src='/images/loader.svg' /></div>}>
    <LazyAvalibility {...props} />
  </React.Suspense>
);

export default Avalibility;
